export type SiteData = { revenueToDate: number; agreementsToDate: number };

export const fallbackData: SiteData = {
  revenueToDate: 15000000000,
  agreementsToDate: 150000,
};
